module.exports = "<div class=\"form-group\">\n    <label class=\"itpx-label\">\n        <ng-content select=[input-label]></ng-content>\n    </label>\n    <p class=\"itpx-under-label\">\n        <small>\n            <ng-content select=[input-guidance]></ng-content>\n        </small>\n    </p>\n    <ng-content select=[input-group]></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-details-group/happy-details-group.component.html
// module id = 958
// module chunks = 0